<app-help-page mainVideo="export-destinations"
               [tutorials]="['export-destination-email']"
               [videos]="['export-destinations', 'exports']"></app-help-page>
